import PriceConverter from '../helpers/PriceConverter'
import { shape, string } from 'prop-types'
import NumberFormat from 'react-number-format'
import { FormattedMessage } from 'react-intl'
import styles from './CalculatedPrice.module.scss'
import { parseQuery } from '../../utils'

export default function CalculatedPrice({ totalPrice, selectedCurrency }) {
  const { chargePrice, originalPrice } = totalPrice
  const query = parseQuery() || {}
  // if the currency is the same as the selected currency, just show the charged price
  if(chargePrice?.currency === (selectedCurrency || query?.currency_code)) {
    return (
      <NumberFormat
        thousandSeparator
        displayType='text'
        prefix={chargePrice?.currency + ' '}
        decimalScale={2}
        fixedDecimalScale
        value={chargePrice?.value}
      />
    )
    // if the currency is different from the selected currency, show the original price converted to selected currency and the charged price
  } else if(
    chargePrice?.currency !== (selectedCurrency || query?.currency_code)
  ) {
    return (
      <div className={styles.price}>
        <PriceConverter
          amount={originalPrice?.value}
          currency={originalPrice?.currency}
          to={selectedCurrency || query?.currency_code}
        />
        <span className={styles.chargedPrice}>
          <FormattedMessage defaultMessage={'* charged price'} />
          &nbsp;
          <NumberFormat
            thousandSeparator
            displayType='text'
            prefix={chargePrice?.currency + ' '}
            decimalScale={2}
            fixedDecimalScale
            value={chargePrice?.value}
          />
        </span>
      </div>
    )
  }
}

CalculatedPrice.propTypes = {
  totalPrice: shape({
    chargePrice: shape({
      value: string,
      currency: string,
    }),
    originalPrice: shape({
      value: string,
      currency: string,
    }),
  }),
  selectedCurrency: string,
}
